import React from "react";
import i18next from "../../services/language/i18next";
import {useProfileForm} from "./hooks";
import TelegramAuthContent from "./TelegramAuthContent";
import {withErrorBoundary} from "../../components/ErrorBoundary";
import FormControlsButtons from "../../components/FormControlButtons";
import {CCard, CCardBody, CCardFooter, CCardHeader, CForm} from "@coreui/react";
import {ARInputWithLabel, ARPhoneInputWithLabel} from "../../components/ReactHookForm/fields";
import Avatar from "./Avatar";
import {REG_EXS} from "../../utils/constants";
import {MESSAGES} from "../../components/ReactHookForm/schemes/messages";
import "./Profile.scss";

const Profile = () => {
  const {
    onFormReset,
    Prompt,
    onFormSubmit,
    form
  } = useProfileForm();
  const {control, trigger, handleSubmit, setFormError} = form;

  return (
    <CCard className="ProfileCard">
      <Prompt/>
      <CCardHeader className="ProfileCard__header profile-header">
        <h1 className="card-header-text">
          {i18next.t("card.title.profile", "Profile")}
        </h1>
      </CCardHeader>
      <CCardBody>
        <CForm
          id="profile-form"
          className="form-horizontal"
          onSubmit={handleSubmit(onFormSubmit)}
        >
          <Avatar
            name="avatar"
            control={control}
          />
          <ARInputWithLabel
            id="first_name"
            name="first_name"
            labelText={i18next.t("form:label.firstName", "First name")}
            placeholder={i18next.t("form:placeholder.firstName", "Enter first name")}
            control={control}
            autoComplete="off"
          />
          <ARInputWithLabel
            id="last_name"
            name="last_name"
            labelText={i18next.t("form:label.lastName", "Last name")}
            placeholder={i18next.t("form:placeholder.lastName", "Enter last name")}
            control={control}
            autoComplete="off"
          />
          <ARInputWithLabel
            id="email"
            name="email"
            labelText={i18next.t("form:label.email", "Email")}
            placeholder={i18next.t("form:placeholder.email", "Enter email")}
            control={control}
            pattern={REG_EXS.EMAIL_CHARACTERS}
            setFormError={setFormError}
            patternMismatchMessage={MESSAGES.EMAIL_INVALID_CHARACTERS}
            autoComplete="off"
          />
          <ARPhoneInputWithLabel
            id="phone"
            name="phone"
            labelText={i18next.t("form:label.phone", "Phone")}
            control={control}
            autoComplete="off"
            block
          />
          <ARInputWithLabel
            id="password"
            name="password"
            type="password"
            labelText={i18next.t("form:label.password_new", "New password")}
            placeholder={i18next.t("form:placeholder.password_new", "Enter new password")}
            control={control}
            trigger={() => trigger("confirm_password")}
            autoComplete="new-password"
          />
          <ARInputWithLabel
            id="confirm_password"
            name="confirm_password"
            type="password"
            labelText={i18next.t("form:label.password_newConfirm", "Confirm new password")}
            placeholder={i18next.t("form:label.password_newConfirm", "Confirm new password")}
            control={control}
            autoComplete="off"
          />
        </CForm>
      </CCardBody>
      <CCardFooter>
        <FormControlsButtons
          form="profile-form"
          onCancelClick={onFormReset}
        />
      </CCardFooter>
      <TelegramAuthContent/>
    </CCard>
  );
};

export default withErrorBoundary(Profile);